// tw.js
export default {
  common: {
    add: '新增',
    edit: '修改',
    delete: '刪除',
    export:'導出',
    setLgSuccess: '設定語言成功',
  },
  header: {
    "ourProduct": "我們的產品",
    "appProduct": "UUPay APP",
    "posProduct": "UUPay 收款機",
    "monitorProduct": "UUPay 控制台",
    "price": "價格",
    "resource": "實用資源",
    "blog": "網誌",
    "document": "教學文件",
    "case": "商戶成功案例",
    "company": "公司",
    "aboutUs": "關於我們",
    "job": "工作機會",
    "contactUs": "聯絡我們",
    "news": "公司新聞",
    "toDownload": "立即使用",
  },
  footer: {
    "address": "香港01廣場1號大廈01樓001室",
    "news": "媒體報導",
    "privacy": "隱私政策聲明",
    "privacyDetail": "條款及細則",
    "copyright": "版權所有",
    "phone": "+110 1000 1000",
    "email": "UUPay123@.com",
    "about": "關於",
    "cooperate": "合作機會",
  },
  home: {
    
  }
}


// WEBPACK FOOTER //
// ./src/lang/tw.js